<template>
    <b-container>
        <h1>Profile</h1>
        <b-nav tabs fill class="mb-4">
            <b-nav-item :to="{ name: 'profileDetails' }">General</b-nav-item>
            <b-nav-item :to="{ name: 'cardDetails' }">Payment</b-nav-item>
        </b-nav>

        <router-view></router-view>
    </b-container>
</template>

<script>
    export default {
        name: "Profile"
    }
</script>

<style scoped>

</style>